import { app } from '../../../app.module'
export interface IMemoData {
  memoId: number
  message: string
  userId: number
  username: string
  userPictureUrl: string
  created: string
  showMemoFlg: number
  toUsers: string
}

/**
 * メモ管理用のコンポーネント
 * @class MemoManagementComponentCtrl
 */
class MemoManagementComponentCtrl {
  private newMemo: IMemoData
  private objectId: string
  private objectType: string
  private snsType: string

  constructor(private $scope) {}

  /**
   * メモ一覧がアップデートされるイベント
   * @param {object} newMemo 追加されたメモ
   */
  public updateMemoList(newMemo: IMemoData): void {
    this.newMemo = newMemo
    this.$scope.$emit('changeMemo', {
      memo: newMemo,
      objectId: this.objectId,
      objectType: this.objectType,
      snsType: this.snsType,
      type: 'add',
    })
  }
}

app.component('memoManagement', {
  bindings: {
    objectType: '@',
    objectId: '@',
    objectData: '<',
    snsType: '@',
    memoCount: '=',
  },
  template: require('./memo-management.pug')(),
  controller: MemoManagementComponentCtrl,
})
